export default "__VITE_ASSET__B5cC3Ymz__"